import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const PascoeValePage = () => <LocationTemplate suburbName="Pascoe Vale" suburbSlug="pascoe-vale" />;

export default PascoeValePage;
